import {useQuery, UseQueryResult} from 'react-query';
import {LayerVO, LegendItemVO, ServicesApi} from '../api';
import {useMapioContext} from '../mapioContext';

export const CACHE_KEY_LAYERS_CONFIG = 'CACHE_KEY_LAYERS_CONFIG';

export const useLayersConfig = (layersConfig?: {[key: string]: LayerVO}): UseQueryResult<{[key: string]: LayerVO}> => {
    const mapioContext = useMapioContext();

    if (!mapioContext?.value) {
        console.error('mapioContext.value je undefined');
        return null;
    }

    const {context, lang} = mapioContext.value;

    return useQuery<{[key: string]: LayerVO}>([CACHE_KEY_LAYERS_CONFIG, lang, context], async () => (await ServicesApi.getLayersConfig(lang, context)).data, {
        enabled: Boolean(lang) && !layersConfig,
        initialData: layersConfig,
        // Konfigurace vrstev je v rámci session statická – refetch na focus okna nechceme (reset viditelnosti vrstev).
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
        refetchOnMount: false,
    });
};
